




















































































































































































import { Vue, Component, Prop, Provide } from 'vue-property-decorator';
import { MountingPortal } from 'portal-vue';
import { http } from '@/http';
import Button from '@/components/Controls/Button/Button.vue';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';
import Spinner from '@/components/Spinner/Spinner.vue';
import Select from '@/components/Controls/Select/Select.vue';
import SmartFilterForm from './SmartFilterForm.vue';
import Declension from '@/components/Declension/Declension.vue';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import scrollbarWidth from '@/utils/scrollbarWidth';
import * as events from '@/metrix/events';
import { FilterFields, ProductCount, SmartFilterModel, SmartFilterProps } from './types';
import { SelectOptions } from '../Controls/Select/types';

@Component({
    components: {
        Select,
        SvgIcon,
        Spinner,
        Button,
        SmartFilterForm,
        Declension,
        MountingPortal,
    },
})
export default class SmartFilter extends Vue implements SmartFilterProps {
    @Prop()
    @Provide()
    public readonly action!: string;

    @Prop()
    @Provide()
    public readonly method!: string;

    @Prop()
    @Provide()
    public readonly url!: string;

    @Prop()
    @Provide()
    public readonly doNotShowSmartFilter!: boolean;

    @Prop()
    @Provide()
    public readonly housingOptions!: SelectOptions;

    @Prop()
    @Provide()
    public readonly housingPlaceholder!: string;

    @Prop()
    @Provide()
    public readonly housing!: string;

    @Prop()
    @Provide()
    public readonly metrix!: any;

    public showPortal: boolean = false;

    public fields: FilterFields = [];

    public model: SmartFilterModel = {};

    public prodCount: number | null = null;

    public lastChanged: string | null = null;

    public get query() {
        const result: Record<string, string[]> = {};

        for (const key in this.model) {
            if (this.model.hasOwnProperty(key)) {
                const element = this.model[key];

                result[key] = Object.entries(element)
                    .filter(([key, val]) => val)
                    .map(([key, val]) => key);
            }
        }

        return Object.entries(result).reduce((prev, [key, value]) => {
            return value.length
                ? (prev ? prev + '&' : '') + value.map((j) => `${key}=${j}`).join('&')
                : prev;
        }, '');
    }

    public needAdditionalHousingNavOutput: boolean =
        document.querySelector('#smart-filter-housing-nav') != null;

    async created() {
        if (this.doNotShowSmartFilter) {
            return;
        }
        this.$wait.start('initial-loading');
        const query = window.location.search.replace(/^[?]/, '');
        await this.fetchData(query);
        this.$wait.end('initial-loading');
    }

    public fieldsToModel(fields: FilterFields = []) {
        const model: SmartFilterModel = {};

        fields.forEach((section) => {
            const _model: Record<string, boolean> = {};
            section.values.forEach((field) => {
                _model[field.value] = field.checked === true;
            });
            model[section.name] = _model;
        });

        return model;
    }

    public async fetchData(query: string, wait?: boolean) {
        if (this.$wait.waiting('request')) {
            return;
        }

        this.$wait.start('request');

        try {
            const hasQueryString = /\?/.test(this.url);
            const separator = hasQueryString ? '&' : '?';
            const url = [this.url, query].filter((v) => v).join(separator);

            const [{ data }] = await Promise.all([
                http.get<{ filterFields: FilterFields; prodCount: ProductCount }>(url),
                new Promise<void>((resolve) =>
                    setTimeout(() => resolve(), wait ? 500 : 0)
                ),
            ]);

            this.fields = data.filterFields;
            this.prodCount = data.prodCount;
            this.model = this.fieldsToModel(data.filterFields);
        } catch (error) {
            this.$errorLog(error);
        } finally {
            this.lastChanged = null;
            this.$wait.end('request');
        }
    }

    public onSmartFilterChange(property: string[], value: any) {
        setValue(this.model, property, value);
        this.lastChanged = property.join('/');
        this.fetchData(this.query, true);

        const metrix = this.$enrichVars(this.metrix || {}, {
            $property: property,
            $value: value,
        });

        this.$metrix.$emit(events.CHANGE, metrix[events.CHANGE]);
    }

    public onSmartFilterSubmit() {
        this.$wait.start('loading');
    }

    public onSmartFilterReset() {
        window.location.href = window.location.pathname;
    }

    public onHousingChange(href: string) {
        window.location.href = href;
    }

    public onTransitionBeforeEnter(_el: HTMLElement) {
        document.body.style.paddingRight = scrollbarWidth() + 'px';
        document.body.style.overflow = 'hidden';
    }

    public onTransitionEnter(el: HTMLElement) {
        disableBodyScroll(el);
        document.body.classList.add('smart-filter-on');
    }

    public onTransitionBeforeLeave(el: HTMLElement) {
        enableBodyScroll(el);
        document.body.classList.remove('smart-filter-on');
    }

    public onTransitionAfterLeave(_el: HTMLElement) {
        document.body.style.paddingRight = '';
        document.body.style.overflow = '';
    }
}

//TODO out
function setValue(target: any, path: string[], value: any) {
    if (!target) {
        return;
    }

    if (!Array.isArray(path)) {
        return;
    }

    const _path = [...path];
    const step = _path.shift();

    if (target[step!] === undefined) {
        Vue.set(target, step!, {});
    }

    if (!_path.length) {
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            target[step!] = { ...target[step!], ...value };
        } else if (Array.isArray(target)) {
            target.splice(Number(step), 1, value);
        } else {
            target[step!] = value;
        }

        return;
    }

    setValue(target[step!], _path, value);
}
